declare global {
    interface Window {
        ENV?: string | Record<string, string>;
    }
}

export interface EnvVariables {
    STAGE?: string;
    stage: string;
    [key: string]: string | undefined;
}

const DEFAULT_ENV = {
    STAGE: 'beta',
};

const getEnvVariables = (): EnvVariables => {
    let rawEnv: Record<string, unknown> = {};

    if (typeof window !== 'undefined' && window.ENV && window.ENV !== '__environment__') {
        rawEnv = typeof window.ENV === 'string'
            ? JSON.parse(window.ENV)
            : (window.ENV as Record<string, unknown>);
    }

    const stage = (rawEnv.STAGE as string) || DEFAULT_ENV.STAGE;

    return {
        ...(rawEnv as Record<string, string | undefined>),
        stage,
    };
};

export const ENV_VARIABLES = getEnvVariables();